import React, { useState } from "react";
import { DetailsPage, HelpPage, HomePage, NotificationsPage, PlantationsPage, ProfilePage } from "./pages/HomePage";
import { ArPage, CountPage, GeneralInfoPage, GrowthPage, LossPage, MappingPage, PlotsPage, ReviewPage, TypeSelectionPage } from "./pages/FieldFlowPage";
import { MapExplorerPage, OfflinePage, QualityPage, StripMappingPage, TrendPage, ValidatorPage } from "./pages/OperationsPage";
import { AdminPage, CitizenPage, DistrictPage, ManagementPage, RoleLoginPage, RoleSelectPage, RoleSplashPage, UpazilaPage, ValidatorHomePage } from "./pages/RolePages";
import { AuditPage, DbHPage, GapFillingPage, InvalidCountPage, LocationPage, MasterDataPage, OfflineSavePage, PhotoPage, ReportsPage, SubmissionPage, UsersPage, ValidatorDetailPage } from "./pages/SupportPages";
import { FieldMetricPage } from "./pages/FieldMetricPages";
import { AnalyticsPage, DistrictReportPage, ReportHubPage } from "./pages/AnalyticsPages";
import { type UserRole } from "./data/roleData";
type Screen = "splash" | "roleSelect" | "roleLogin" | "home" | "type" | "general" | "location" | "mapping" | "plots" | "count" | "invalidCount" | "growth" | "ar" | "dbh" | "photo" | "loss" | "review" | "submission" | "offlineSave" | "offline" | "plantations" | "details" | "trend" | "mapExplorer" | "validator" | "validatorHome" | "validatorDetail" | "quality" | "notifications" | "help" | "profile" | "strip" | "district" | "districtReport" | "upazila" | "management" | "nationalMap" | "analytics" | "admin" | "citizen" | "reports" | "users" | "masterData" | "audit" | "gapFilling" | "myPlantations" | "monthlyMonitoring" | "pendingValidation" | "work";
export function App() {
  const [screen, setScreen] = useState<Screen>("splash");
  const [role, setRole] = useState<UserRole>("field");
  const go = (next: string) => setScreen(next === "work" ? "offline" : next as Screen);
  const renderScreen = () => {
    switch (screen) {
      case "splash":
        return <RoleSplashPage go={go} data-id="element-0" data-mp="swqcvjfihlyi" />;
      case "roleSelect":
        return <RoleSelectPage go={go} setRole={setRole} data-id="element-1" data-mp="35glr3hkw7k1" />;
      case "roleLogin":
        return <RoleLoginPage go={go} role={role} data-id="element-2" data-mp="3ud1e95yxri91" />;
      case "home":
        return <HomePage go={go} data-id="element-3" data-mp="3uevs60bsia3m" />;
      case "type":
        return <TypeSelectionPage go={go} data-id="element-4" data-mp="d57d4waue6fw" />;
      case "general":
        return <GeneralInfoPage go={go} data-id="element-5" data-mp="d2l6qzzotwz9" />;
      case "location":
        return <LocationPage go={go} data-id="element-6" data-mp="86mg15qw02vo" />;
      case "mapping":
        return <MappingPage go={go} data-id="element-7" data-mp="3gle7udba4tcj" />;
      case "plots":
        return <PlotsPage go={go} data-id="element-8" data-mp="3gm64zskiyz4x" />;
      case "count":
        return <CountPage go={go} data-id="element-9" data-mp="3bmbdpnwu87jc" />;
      case "invalidCount":
        return <InvalidCountPage go={go} data-id="element-10" data-mp="3bnmerfywf16r" />;
      case "growth":
        return <GrowthPage go={go} data-id="element-11" data-mp="3qaxsnoijyxa1" />;
      case "ar":
        return <ArPage go={go} data-id="element-12" data-mp="3qcr0360zplj3" />;
      case "dbh":
        return <DbHPage go={go} data-id="element-13" data-mp="3lkhg06mk3foq" />;
      case "photo":
        return <PhotoPage go={go} data-id="element-14" data-mp="3ljphamxnx1u8" />;
      case "loss":
        return <LossPage go={go} data-id="element-15" data-mp="3limuor7dhlk4" />;
      case "review":
        return <ReviewPage go={go} data-id="element-16" data-mp="2xtv94ioag1gb" />;
      case "submission":
        return <SubmissionPage go={go} data-id="element-17" data-mp="2svtovuf4lw39" />;
      case "offlineSave":
        return <OfflineSavePage go={go} data-id="element-18" data-mp="2svagp5fa2m2f" />;
      case "offline":
        return <OfflinePage go={go} data-id="element-19" data-mp="18d9ds8p0zot8" />;
      case "plantations":
        return <PlantationsPage go={go} data-id="element-20" data-mp="18cgfzx81o9n8" />;
      case "details":
        return <DetailsPage go={go} data-id="element-21" data-mp="1d4rdktfbbjcm" />;
      case "trend":
        return <TrendPage go={go} data-id="element-22" data-mp="1d6kowm0verqy" />;
      case "mapExplorer":
        return <MapExplorerPage go={go} data-id="element-23" data-mp="ygmu3n8fr3ss" />;
      case "validator":
        return <ValidatorPage go={go} data-id="element-24" data-mp="ydqyi5k28r7i" />;
      case "validatorHome":
        return <ValidatorHomePage go={go} data-id="element-25" data-mp="13f7vhpzfbtit" />;
      case "validatorDetail":
        return <ValidatorDetailPage go={go} data-id="element-26" data-mp="1r3r6id9uykel" />;
      case "quality":
        return <QualityPage go={go} data-id="element-27" data-mp="1r26bynnjn1gq" />;
      case "notifications":
        return <NotificationsPage go={go} data-id="element-28" data-mp="1w2arobgmns5w" />;
      case "help":
        return <HelpPage go={go} data-id="element-29" data-mp="1i3kvcy1mtwil" />;
      case "profile":
        return <ProfilePage go={go} data-id="element-30" data-mp="1i2sw9d8ttgnk" />;
      case "strip":
        return <StripMappingPage go={go} data-id="element-31" data-mp="1m560tybu78ir" />;
      case "district":
        return <DistrictPage go={go} data-id="element-32" data-mp="1m3l6a8pivpkw" />;
      case "upazila":
        return <UpazilaPage go={go} data-id="element-33" data-mp="6onpydl54up2" />;
      case "management":
      case "nationalMap":
        return <ManagementPage go={go} data-id="element-34" data-mp="6qs5jsseji56" />;
      case "analytics":
        return <AnalyticsPage go={go} data-id="element-35" data-mp="aqsita3rlnan" />;
      case "districtReport":
        return <DistrictReportPage go={go} data-id="element-36" data-mp="qwvpy9pmqf49" />;
      case "admin":
        return <AdminPage go={go} data-id="element-37" data-mp="qygk3y817w1l" />;
      case "citizen":
        return <CitizenPage go={go} data-id="element-38" data-mp="m5x7b3h654xu" />;
      case "reports":
        return <ReportHubPage go={go} data-id="element-39" data-mp="m549is06tpru" />;
      case "users":
        return <UsersPage go={go} data-id="element-40" data-mp="h6sve52v0t3t" />;
      case "masterData":
        return <MasterDataPage go={go} data-id="element-41" data-mp="h59i8nci2y69" />;
      case "audit":
        return <AuditPage go={go} data-id="element-42" data-mp="c90xmufjacrp" />;
      case "gapFilling":
        return <GapFillingPage go={go} data-id="element-43" data-mp="c6eoiqczvp7d" />;
      case "myPlantations":
        return <FieldMetricPage mode="myPlantations" go={go} data-id="element-44" data-mp="19uot9d460r26" />;
      case "monthlyMonitoring":
        return <FieldMetricPage mode="monthlyMonitoring" go={go} data-id="element-45" data-mp="14xydkqw9vxha" />;
      case "pendingValidation":
        return <FieldMetricPage mode="pendingValidation" go={go} data-id="element-46" data-mp="zx2bmivhelei" />;
      default:
        return <HomePage go={go} data-id="element-47" data-mp="vw8mjm6az0k1" />;
    }
  };
  return <div className="min-h-screen w-full bg-[#dfe9e1] py-0 text-[#1F2D24] sm:flex sm:items-center sm:justify-center sm:p-6" data-id="element-48" data-mp="vv71qpzhizp4"><div className="relative min-h-screen w-full overflow-hidden bg-[#EEF7F0] sm:min-h-[780px] sm:max-w-[390px] sm:rounded-[28px] sm:shadow-[0_20px_60px_rgba(15,81,50,.24)]" data-id="element-49" data-mp="3kpm7sejwjbwe">{renderScreen()}</div></div>;
}